import { useState, useEffect } from "react";
import { ReactSession } from "react-client-session";
import { useNavigate, Link } from "react-router-dom";

import axios from "axios";
import ReactGA from "react-ga4";

import { formatCreditUsage } from "../../utils/CreditFormat";
import {
  Box,
  Button,
  Flex,
  Text,
  IconButton,
  HStack,
  Stack,
  Image,
  Switch,
  FormControl,
  FormLabel,
  Container,
  RadioGroup,
  Radio,
  TableContainer,
  Table,
  TableCaption,
  Thead,
  Tr,
  Th,
  Tbody,
  Tooltip,
  Td, Modal, ModalOverlay, ModalContent, ModalBody, ModalFooter, ModalCloseButton
} from "@chakra-ui/react";
import { FaCopy, FaCheckSquare, FaCheckCircle } from "react-icons/fa";
import { BeatLoader } from 'react-spinners';
import { FaCheck } from "react-icons/fa";
import { ImCross } from "react-icons/im";
import { MdCancel, MdRefresh  } from "react-icons/md";
import { WarningTwoIcon } from "@chakra-ui/icons";

import LinkDarkCards from "./LinkDarkCards";

const Overview = (props) => {
  const navigate = useNavigate();
  const months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  const rewardSysActive = process.env.REACT_APP_REWARD_SYSTEM ?? "inactive";
  const [errOcc, setErrOcc] = useState(false);
  const [data, setData] = useState(null);
  const [copied, setCopied] = useState(false);
  const [apiKeyString, setApiKeyString] = useState("");

  const [copiedRPC, setCopiedRPC] = useState(false);
  const [showDevnet, setDevnet] = useState(false);

  const [selectedUrl,setSelectedUrl] = useState("1");

  const [activeUrl,setActiveUrl] = useState(`https://rpc.shyft.to?api_key=${apiKeyString}`);

  const [gRPCStatus,setGRPCStatus] = useState(false);

  const [refreshKey, setRefreshKey] = useState("UNREFRESHED");
  const [showRefreshModal,setShowRefreshModal] = useState(false);
  const [refreshError,setRefreshError] = useState("");

  const refreshApiKey = () => {
    setRefreshError("");
    setRefreshKey("REFRESHING");
    const token = ReactSession.get("xTkn") ?? "";
    if (token !== "") {
      const endPoint = process.env.REACT_APP_AUTH_EP;
      axios({
        url: `${endPoint}dashboard/refresh_api_key`,
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      })
        .then((res) => {
          if (res.data.success === true) {
            setApiKeyString("--");
            setRefreshKey("REFRESHED");
            setTimeout(() => {
              setRefreshKey("UNREFRESHED");
              setShowRefreshModal(false);
              ReactSession.set("xTkn", "");
              navigate("/get-api-key?refreshed=true");
            }, 1200);
          }
        })
        // Catch errors if any
        .catch((err) => {
          console.warn(err);
          setRefreshError(err.response?.data?.error?.toString() ?? err.message);
          setTimeout(() => {
              setRefreshKey("UNREFRESHED");
            }, 1500);
        });
    }
  };


  useEffect(() => {
    if(showDevnet){
      if(selectedUrl === "1")
        setActiveUrl(`https://devnet-rpc.shyft.to?api_key=${apiKeyString}`);
      else if(selectedUrl === "2")
        setActiveUrl(`wss://devnet-rpc.shyft.to?api_key=${apiKeyString}`);
      else if(selectedUrl === "3")
        setActiveUrl(`https://programs.shyft.to/v0/graphql/?api_key=${apiKeyString}&network=devnet`);
    }
    else {
      if(selectedUrl === "1")
        setActiveUrl(`https://rpc.shyft.to?api_key=${apiKeyString}`);
      else if(selectedUrl === "2")
        setActiveUrl(`wss://rpc.shyft.to?api_key=${apiKeyString}`);
      else if(selectedUrl === "3")
        setActiveUrl(`https://programs.shyft.to/v0/graphql/?api_key=${apiKeyString}&network=mainnet-beta`);
    }
  }, [selectedUrl,showDevnet]);


  useEffect(() => {
    document.title = "User Dashboard - SHYFT";
    ReactGA.send({ hitType: "pageview", page: "/dashboard/overview" });
    ReactSession.set("lastNavigate", "");
  }, []);
  useEffect(() => {
    const token = ReactSession.get("xTkn") ?? "";

    if (token !== "") {
      const endPoint = process.env.REACT_APP_AUTH_EP;
      axios({
        url: `${endPoint}dashboard/billing`,
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "ngrok-skip-browser-warning": "69420",
        },
      })
        .then((res) => {
          if (res.data.success === true) {
            setData(res.data);
            setApiKeyString(res.data.result.api_key);
            setActiveUrl(`https://rpc.shyft.to?api_key=${res.data.result.api_key ?? "--"}`)
            if(res.data.result.current_plan === "JUPITER")
            {
              if(Number(res.data.result?.total_credits) < 500001)
                props.setCurrentPlan("FREE");
              else if(Number(res.data.result?.total_credits) > 500001 && Number(res.data.result?.total_credits) < 10000001)
                props.setCurrentPlan("HACK");
              else if(Number(res.data.result?.total_credits) > 10000001 && Number(res.data.result?.total_credits) < 100000001)
                props.setCurrentPlan("LAUNCH");
              else if(Number(res.data.result?.total_credits) > 100000001 && Number(res.data.result?.total_credits) < 500000010)
                props.setCurrentPlan("SCALE");
              else
                props.setCurrentPlan(res.data.result.current_plan ?? "FREE");
            }
            else {
              props.setCurrentPlan(res.data.result.current_plan ?? "FREE");

            }
            if (res.data.result.current_plan === "FREE")
              ReactSession.set("ifr", "FREE");
            else ReactSession.set("ifr", "Paid");
            ReactSession.set("ceDt", `${new Date(res.data.result.cycle_end).getUTCDate()}-${months[new Date(res.data.result.cycle_end).getUTCMonth()]}
            ${new Date(res.data.result.cycle_end).getUTCFullYear()}`);

            props.setReferralBillingAmount(res.data?.result?.amount_payable ?? 0);
          } else {
            setErrOcc(true);
          }
        })
        // Catch errors if any
        .catch((err) => {
          console.warn(err);
          setErrOcc(true);
          props.setLoading(false);
        });
    } else {
      navigate("/get-api-key");
    }
  }, []);

  useEffect(() => {
    if (data !== null || errOcc === true) props.setLoading(false);
  }, [data, errOcc]);

  useEffect(() => {
    const token = ReactSession.get("xTkn") ?? "";

    if (token !== "" && rewardSysActive === "active") {
      const endPoint = process.env.REACT_APP_AUTH_EP;
      axios({
        url: `${endPoint}dashboard/reward/active`,
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "ngrok-skip-browser-warning": "69420",
          "Content-Type": "application/json",
        },
      })
        .then((res) => {
          if (res.data.success === true) {
            //console.log("Im here",res.data.result);
            props.setCurrentOffer(res.data.result.reward);
          }
          props.setOfferLoad("loaded");
        })
        // Catch errors if any
        .catch((err) => {
          console.warn(err);
          if (err.response.status === 404) {
            props.setOfferLoad("loaded");
          } else {
            props.setOfferLoad("error");
          }
        });
    }
  }, []);

  useEffect(() => {
    const token = ReactSession.get("xTkn") ?? "";

    if (token !== "" && rewardSysActive === "active") {
      const endPoint = process.env.REACT_APP_AUTH_EP;
      axios({
        url: `${endPoint}dashboard/get_grpc_details`,
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "ngrok-skip-browser-warning": "69420",
          "Content-Type": "application/json",
        },
      })
        .then((res) => {
          if (res.data.success === true) {
            const gRPCPlanPresent = res.data.result?.token;
            if (gRPCPlanPresent && gRPCPlanPresent !== 1) setGRPCStatus(true);
          }
        })
        // Catch errors if any
        .catch((err) => {
          console.warn(err);
          
        });
    }
  }, []);

  

  const copyCon = () => {
    navigator.clipboard.writeText(data.result?.api_key ?? "--");
    setCopied(true);
    setTimeout(() => {
      setCopied(false);
    }, 2000);
  };
  const copyConRPC = () => {
    navigator.clipboard.writeText(activeUrl);
    setCopiedRPC(true);
    setTimeout(() => {
      setCopiedRPC(false);
    }, 1200);
  };

  return (
    <>
      {!props.isLoading && errOcc === true && (
        <Box
          as="div"
          bg="black"
          px={{ base: "16px", md: "24px", xl: "32px" }}
          py={{ base: "16px", md: "24px" }}
          borderRadius={"14px"}
        >
          <Box textAlign={"center"} color={"brand.grey"}>
            <Text fontSize={"xl"}>
              Some Error Occured while Loading Data. Please Try Again Later.
            </Text>
          </Box>
        </Box>
      )}
      <Modal isOpen={showRefreshModal} onClose={() => setShowRefreshModal(false)} blockScrollOnMount={true}>
          <ModalOverlay />
          <ModalContent bg={"brand.black"} border={"1px solid"} borderColor={"brand.midGrey"} borderRadius={"xl"}>
          
          <ModalCloseButton />
          <ModalBody py={4}>
              <Text
                  as="div"
                  fontSize={{ base: "md", md: "md"}}
                  fontWeight={"600"}
                  color={"brand.white"}
                  textAlign={"center"}
                  fontFamily={"heading"}
              >
                  Are you sure you want to <Text as={"span"} color={"brand.yellow"}>generate</Text> a new API key?
              </Text>
              <Text
                  as="div"
                  fontSize={{ base: "xs", md: "xs" }}
                  fontWeight={"400"}
                  color={"brand.white"}
                  textAlign={"start"}
                  mt={4}
                  
              >
                  Note: You current api key will stop working (within ~5 mins), and a new one would be generated for you instantly.
              </Text>
              {refreshError !== null && <Text
                  as="div"
                  fontSize={{ base: "xs", md: "xs" }}
                  fontWeight={"500"}
                  color={"brand.red"}
                  textAlign={"start"}
                  mt={4}
                  
              >
                 {refreshError}
              </Text>}
          </ModalBody>
              <ModalFooter>
                  {refreshKey === "UNREFRESHED" && <Flex width={"100%"} justifyContent={"center"}>
                      <Button colorScheme='blue' mr={3} onClick={refreshApiKey}
                          color={"brand.dark"}
                          bg={"brand.white"}
                          _hover={{
                            bg: "brand.black",
                            color: "brand.white",
                          }}
                          px={"20px"}
                          fontFamily={"heading"}
                          fontSize={"12px"}
                          lineHeight={"12px"}
                          size={"sm"}
                          borderRadius={"full"}
                      >
                          Yes
                      </Button>
                      <Button colorScheme='blue' mr={3} onClick={() => setShowRefreshModal(false)}
                          color={"brand.dark"}
                          bg={"brand.white"}
                          _hover={{
                            bg: "brand.black",
                            color: "brand.white",
                          }}
                          px={"20px"}
                          fontFamily={"heading"}
                          fontSize={"12px"}
                          lineHeight={"12px"}
                          size={"sm"}
                          borderRadius={"full"}    
                      >
                          No
                      </Button>
                  </Flex>}
                  {refreshKey === "REFRESHING" && <Flex w={"100%"} justifyContent={"center"} height={"24px"}>
                      <BeatLoader color="#fff" loading={true} size={10} />
                  </Flex>}
                  {refreshKey === "REFRESHED" && <Flex w={"100%"} justifyContent={"center"} height={"24px"}>
                      <FaCheck color="#39e75f"/>
                  </Flex>}
                  {refreshKey === "REFRESHED_ERROR" && <Flex w={"100%"} justifyContent={"center"} height={"24px"}>
                      <ImCross color="#e3242b"/>
                  </Flex>}
                  
              </ModalFooter>
          </ModalContent>
      </Modal>
      {!props.isLoading && data !== null && (
        <Box>
          <Container maxW={"8xl"}>
            <Box mt={6}>
              <Flex
                direction={{ base: "column", lg: "row" }}
                justifyContent={{ base: "center", lg: "space-between" }}
                alignItems={"center"}
              >
                <Box w={"full"} maxW={{ base: "100%", lg: "49%" }}>
                  <Flex
                    justifyContent={{
                      base: "space-between",
                      lg: "space-between",
                    }}
                    alignItems={"center"}
                    pb={2}
                    px={1}
                  >
                    <Text
                        as="span"
                      fontSize={{ base: "16px", lg: "20px" }}
                      fontFamily={"heading"}
                      letterSpacing={"0.03em"}
                      color={"brand.lighterWhite"}
                    >
                      Your API Key
                    </Text>
                  </Flex>
                  <Box
                    as="div"
                    bg="black"
                    px={{ base: "16px", md: "24px", xl: "32px" }}
                    py={{ base: "16px", md: "18px" }}
                    borderRadius={"14px"}
                  >
                    <Flex
                      justifyContent={"space-between"}
                      alignItems={"center"}
                    >
                      <Box>
                        <Flex>
                          <Text
                          as={'span'}
                            fontSize={{ base: "14px", lg: "16px" }}
                            letterSpacing={"0.03em"}
                            color={"brand.lighterWhite"}
                          >
                            {data.result.api_key ?? "--"}
                          </Text>
                          {!props.apiKeyRoated && <Box>
                            <Tooltip
                              label="Please refresh your API Key. To ensure a zero-downtime update, your API Key will remain valid for ~5 minutes after the new one is generated."
                              fontSize="xs"
                            >
                              <Box ps={2} marginTop={"-2px"}>
                                <WarningTwoIcon color={"red"} />
                              </Box>
                            </Tooltip>
                          </Box>}
                        </Flex>
                      </Box>
                      <Box>
                        <Flex justifyContent={"flex-end"} spacing={4}>
                          <Button
                            size={"xs"}
                            fontSize={"xs"}
                            fontWeight={"400"}
                            fontFamily={"heading"}
                            borderRadius={"full"}
                            py={"8px"}
                            px={{ base: "10px", lg: "10px" }}
                            bg={"transparent"}
                            border="1px solid"
                            borderColor="brand.red"
                            color={"brand.white"}
                            leftIcon={<MdRefresh />}
                            textAlign={"center"} 
                            mt={1}
                            _hover={{
                              bg: "transparent"
                            }}
                            onClick={() => setShowRefreshModal(true)}
                          >
                            New
                          </Button>
                          {copied ? (
                            <IconButton
                              size={"sm"}
                              aria-label="Copy to clipboard"
                              icon={<FaCheckSquare size={"18"} />}
                              bg={"transparent"}
                              color={"green.300"}
                              _hover={{ bg: "transparent" }}
                            />
                          ) : (
                            <IconButton
                              size={"sm"}
                              aria-label="Copy to clipboard"
                              icon={<FaCopy size={"18"} />}
                              onClick={copyCon}
                              bg={"transparent"}
                              color={"brand.yellow"}
                              _hover={{ bg: "transparent" }}
                            />
                          )}
                        </Flex>
                        
                      </Box>
                      
                    </Flex>
                  </Box>
                </Box>
                <Box
                  w={"full"}
                  maxW={{ base: "100%", lg: "49%" }}
                  mt={{ base: "16px", lg: "0px" }}
                >
                  <Flex
                    justifyContent={"space-between"}
                    alignItems={"center"}
                    pb={2}
                    px={1}
                  >
                    <Text
                     as={'span'}
                      fontSize={{ base: "16px", lg: "20px" }}
                      fontFamily={"heading"}
                      letterSpacing={"0.03em"}
                      color={"brand.lighterWhite"}
                    >
                      Current Plan
                    </Text>
                    
                  </Flex>
                  <Box
                    as="div"
                    bg="black"
                    px={{ base: "16px", md: "24px", xl: "32px" }}
                    py={{ base: "15px", md: "12px",xl: "22px" }}
                    borderRadius={"14px"}
                  >
                    <Flex
                      justifyContent={"space-between"}
                      alignItems={"center"}
                    >
                      <Box>
                        <Flex flexDir={{base: "row", lg:"column", xl: "row"}} alignItems={"center"} flexWrap={"wrap"}>
                          <Box>
                            <Text
                              as={'span'}
                              fontSize={{ base: "13px", xl: "16px" }}
                              letterSpacing={"0.01em"}
                              color={"brand.lighterWhite"}
                            >
                              API/RPC Plan: <Text as="span" color={"brand.yellow"} fontWeight={{base:"400", md:"400"}}>{data.result?.current_plan === "JUPITER"?"FREE":data.result?.current_plan}</Text> +
                            </Text>
                          </Box>
                          <Box ps={{base:0, md: 1}}>
                            <Flex alignItems={"center"} justifyContent={"flex-start"}>
                              <Text as={"div"} color={"brand.lighterWhite"} fontSize={{ base: "13px", xl: "16px" }}>gRPC: </Text>
                              {/* {gRPCStatus?<Box ps={{base: 0,md: 1}}><FaCheckCircle color="#03C04A" size={17}/></Box>:<Box ps={1} color="#E33535"><MdCancel color="#E33535" size={18}/></Box>} */}
                              {gRPCStatus?<Box as="div" color="#39FF14" ps={1} fontSize={{ base: "13px", xl: "16px" }} fontWeight={400}>Enabled</Box>:<Box ps={1} color="#E33535" fontSize={{ base: "13px", xl: "16px" }} fontWeight={400}>Disabled</Box>}
                            </Flex>
                          </Box>
                        </Flex>
                        
                      </Box>
                      {data.result.current_plan === "FREE" || data.result.current_plan === "JUPITER" ? (
                        <Link to="/pricing">
                          <Box
                            size={"xs"}
                            fontSize={"xs"}
                            fontWeight={"400"}
                            fontFamily={"heading"}
                            borderRadius={"full"}
                            px={{ base: "12px", xl: "24px" }}
                            py={{ base: "6px", lg: "6px" }}
                            bg={"transparent"}
                            border="2px solid"
                            borderColor="brand.red"
                            color={"brand.white"}
                            my={"-2"}
                            _hover={{
                              bg: "brand.red",
                            }}
                            textAlign={"center"}
                          >
                            Upgrade Plan
                          </Box>
                        </Link>
                      ) : (
                        <Text
                        as={'span'}
                        fontSize={{ base: "14px", lg: "16px" }}
                          fontFamily={"body"}
                          fontWeight={"400"}
                          letterSpacing={"0.03em"}
                          color={"brand.lighterWhite"}
                        >
                          {data.result?.currency === "inr" ? "₹ " : "$ "}
                          {data.result?.amount_payable ?? "--"}
                        </Text>
                      )}
                      {/* <Box>
                        <Flex alignItems={"center"}>
                          <Text as={"div"} color={"brand.lighterWhite"}>gRPC Access: </Text>
                          {gRPCStatus?<Box ps={1}><FaCheckCircle color="#03C04A" size={20}/></Box>:<Box ps={1}><MdCancel color="#E33535" size={20}/></Box>}
                        </Flex>
                      </Box> */}
                    </Flex>
                  </Box>
                </Box>
              </Flex>
            </Box>
            <Box mt={12}>
              <Flex
                direction={{ base: "column", lg: "row" }}
                justifyContent={{ base: "center", lg: "space-between" }}
                alignItems={"center"}
              >
                <Box w={"full"} maxW={{ base: "100%", lg: "full" }}>
                  <Flex
                    justifyContent={{
                      base: "space-between",
                      lg: "space-between",
                    }}
                    alignItems={"center"}
                    pb={2}
                    px={1}
                  >
                    <Box w={"full"} maxW={{ base: "100%", lg: "410px" }}>
                      <RadioGroup onChange={setSelectedUrl} value={selectedUrl} defaultValue="1">
                        <Stack direction={{base:'column', md: "row"}} spacing={{base: 2, md: 4, lg: 8}} color={"brand.lighterWhite"}>
                          <Radio value={"1"} colorScheme='switchYellow' color={"brand.lighterWhite"}>RPC</Radio>
                          <Radio value={"2"} colorScheme='switchYellow' color={"brand.lighterWhite"}>Web Socket</Radio>
                          {/* <Radio value={"3"} colorScheme='switchYellow' color={"brand.lighterWhite"}>GraphQL</Radio> */}
                        </Stack>
                      </RadioGroup>
                    </Box>
                    <Box>
                      <FormControl display="flex" alignItems="center" pb={{base: 2, lg: 0}}>
                        <FormLabel
                          htmlFor="network-select"
                          mb="0"
                          color={showDevnet ? "brand.midGrey" : "brand.white"}
                          fontWeight={"300"}
                          fontSize={{ base: "14px", lg: "16px" }}
                          transition={"all 0.2s ease"}
                        >
                          Mainnet
                        </FormLabel>
                        <Switch
                          id="network-select"
                          onChange={(e) => setDevnet(!showDevnet)}
                          colorScheme="gray"
                        />
                        <FormLabel
                          htmlFor="network-select"
                          mb="0"
                          color={showDevnet ? "brand.white" : "brand.midGrey"}
                          fontWeight={"300"}
                          ps={"3"}
                          fontSize={{ base: "14px", lg: "16px" }}
                          transition={"all 0.2s ease"}
                        >
                          Devnet
                        </FormLabel>
                      </FormControl>
                    </Box>
                  </Flex>
                  <Box
                    as="div"
                    bg="black"
                    px={{ base: "16px", md: "24px", xl: "32px" }}
                    py={{ base: "16px", md: "18px" }}
                    borderRadius={"14px"}
                  >
                    <Flex
                      justifyContent={"space-between"}
                      alignItems={"center"}
                    >
                      <Text
                        as={"span"}
                        fontSize={{ base: "14px", lg: "16px" }}
                        letterSpacing={"0.03em"}
                        color={"brand.lighterWhite"}
                      >
                          {activeUrl}
                      </Text>
                      {copiedRPC ? (
                        <IconButton
                          size={"sm"}
                          aria-label="Copy to clipboard"
                          icon={<FaCheckSquare size={"18"} />}
                          bg={"transparent"}
                          color={"green.300"}
                          _hover={{ bg: "transparent" }}
                        />
                      ) : (
                        <IconButton
                          size={"sm"}
                          aria-label="Copy to clipboard"
                          icon={<FaCopy size={"18"} />}
                          onClick={copyConRPC}
                          bg={"transparent"}
                          color={"brand.yellow"}
                          _hover={{ bg: "transparent" }}
                        />
                      )}
                    </Flex>
                  </Box>
                </Box>
              </Flex>
            </Box>
            <Box mt={12}>
              <Flex
                justifyContent={"space-between"}
                alignItems={"center"}
                pb={3}
                px={1}
              >
                <Text
                    as={"div"}
                  fontSize={{ base: "16px", lg: "20px" }}
                  fontFamily={"heading"}
                  letterSpacing={"0.03em"}
                  color={"brand.lighterWhite"}
                >
                  Credits & Usage
                </Text>
                {data.result.cycle_start ? (
                  <Text
                    fontSize={{ base: "12px", md: "14px" }}
                    fontWeight={"300"}
                    color={"brand.lighterWhite"}
                  >
                    {new Date(data.result.cycle_start).getUTCDate()}{" "}
                    {months[new Date(data.result.cycle_start).getUTCMonth()]}{" "}
                    {new Date(data.result.cycle_start).getUTCFullYear()} -{" "}
                    {new Date(data.result.cycle_end).getUTCDate()}{" "}
                    {months[new Date(data.result.cycle_end).getUTCMonth()]}{" "}
                    {new Date(data.result.cycle_end).getUTCFullYear()}
                  </Text>
                ) : (
                  <Text
                    fontSize={{ base: "12px", md: "16px" }}
                    fontWeight={"300"}
                    color={"brand.lighterWhite"}
                  >
                    --
                  </Text>
                )}
              </Flex>
              
            </Box>
            <Box
              as="div"
              bg="black"
              px={{ base: "16px", md: "24px", xl: "32px" }}
              py={{ base: "16px", md: "24px", xl: "32px" }}
              borderRadius={"14px"}
              border={"2px solid"}
              borderColor={"brand.red"}
            >
              <TableContainer>
                <Table variant='simple' className="overview_table">
                  <Thead fontFamily={"heading"}>
                    <Tr>
                      <Th textTransform={"capitalize"} fontSize={"md"} fontWeight={"400"} letterSpacing={"0px"}></Th>
                      <Th textTransform={"capitalize"} fontSize={"md"} fontWeight={"400"} letterSpacing={"0px"} textAlign={"center"}>Requests</Th>
                      <Th textTransform={"capitalize"} fontSize={"md"} fontWeight={"400"} letterSpacing={"0px"} textAlign={"center"}>Per unit</Th>
                      <Th isNumeric textTransform={"capitalize"} fontSize={"md"} fontWeight={"400"} letterSpacing={"0px"}>Total</Th>
                    </Tr>
                  </Thead>
                  <Tbody>
                    <Tr>
                      <Td>API </Td>
                      <Td>{data.result?.total_api_calls ?? 0}</Td>
                      <Td>x 100</Td>
                      <Td>{data.result?.total_api_calls ? `${data.result.total_api_calls ?? 0}00`: "0"}</Td>
                    </Tr>
                    {/* <Tr>
                      <Td>Callbacks</Td>
                      <Td>{data.result?.total_callback_triggered ?? 0}</Td>
                      <Td>x 1</Td>
                      <Td>{data.result?.total_callback_triggered ?? 0}</Td>
                    </Tr> */}
                    <Tr>
                      <Td>RPCs</Td>
                      <Td>{data.result?.total_rpc_calls ?? 0}</Td>
                      <Td>x 1</Td>
                      <Td>{data.result?.total_rpc_calls ?? 0}</Td>
                    </Tr>
                    {/* <Tr>
                      <Td>GraphQL</Td>
                      <Td>{data.result?.total_gql_calls ?? 0}</Td>
                      <Td>x 100</Td>
                      <Td>{data.result?.total_gql_calls ? `${data.result.total_gql_calls ?? 0}00`: "0"}</Td>
                    </Tr> */}
                    <Tr>
                      <Td>Credits Consumed</Td>
                      <Td></Td>
                      <Td isNumeric></Td>
                      {/* <Td>{data.result?.credit_used ?? 0} <span style={{color: "#f9f9f9", fontWeight: "400"}}>/{formatCreditUsage(data.result.total_credits ?? 0)}</span></Td> */}
                      <Td>{((data.result?.total_api_calls ?? 0)*100)+((data.result?.total_rpc_calls ?? 0)*1)} <span style={{color: "#f9f9f9", fontWeight: "400"}}>/{data.result?.total_credits === 0?<span style={{ fontSize: "20px", lineHeight: "16px"}}>∞</span>:formatCreditUsage(data.result.total_credits ?? 0)}</span></Td>
                    </Tr>
                  </Tbody>
                </Table>
              </TableContainer>
            </Box>
            <Box mt={12}>
              <Flex
                justifyContent={"space-between"}
                alignItems={"center"}
                px={1}
              >
                <Text
                    as={"div"}
                  fontSize={{ base: "16px", lg: "20px" }}
                  fontFamily={"heading"}
                  letterSpacing={"0.03em"}
                  color={"brand.lighterWhite"}
                >
                  Developer Tools
                </Text>
              </Flex>
              <Flex
                direction={{ base: "column", lg: "row" }}
                justifyContent={{ base: "center", lg: "space-between" }}
                alignItems={"center"}
              >
                <Box w={"full"} maxW={{ base: "100%", lg: "49%" }}>
                  <LinkDarkCards
                    title="Documentation"
                    link="https://docs.shyft.to/"
                  />
                </Box>
                <Box w={"full"} maxW={{ base: "100%", lg: "49%" }}>
                  <LinkDarkCards
                    title="SHYFT SDK"
                    link="https://www.npmjs.com/package/@shyft-to/js"
                  />
                </Box>
              </Flex>
              <Flex
                direction={{ base: "column", lg: "row" }}
                justifyContent={{ base: "center", lg: "space-between" }}
                alignItems={"center"}
              >
                <Box w={"full"} maxW={{ base: "100%", lg: "49%" }}>
                  <LinkDarkCards
                    title="Ladybug SDK"
                    link="https://www.npmjs.com/package/@shyft-to/ladybug-sdk"
                  />
                </Box>
                <Box w={"full"} maxW={{ base: "100%", lg: "49%" }}>
                  <LinkDarkCards
                    title="Postman Docs"
                    link="https://documenter.getpostman.com/view/18419720/UzQvt5Kf"
                  />
                </Box>
              </Flex>
            </Box>
          </Container>
        </Box>
      )}
    </>
  );
};

export default Overview;
